import { Box, Button } from "@mui/material"
import { useEffect } from "react";
import React from "react";
import EndCurrentModal from "./EndCurrentModal";
import EndModal from "./EndModal";

import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

import { flexSpaceR } from "../Styles/EvaluationToolTheme"
import { AnswersType } from "../Models/AnswersType";
import { evaluationStageType } from "../Models/EvaluationStageType";
import { PolyglotContext } from "../../../polyglot/polyGlotContext";
import { useContext } from "react";

interface BackForwardButtonBoxProps {
    makeVisible: boolean;
    activePage: string;
    collectedAnswersCopy: AnswersType;
    evaluationStage: evaluationStageType;
    setCollectedAnswers: React.Dispatch<React.SetStateAction<AnswersType>>;
    setPageToStart?: () => void;
    collectedAnswers: AnswersType;
}

const BackForwardButtonBox: React.FC<BackForwardButtonBoxProps> = ({
    makeVisible,
    activePage,
    collectedAnswersCopy,
    evaluationStage,
    setCollectedAnswers,
    setPageToStart,
    collectedAnswers,
}) => {
    const { polyglot } = useContext(PolyglotContext)

    const visibility = makeVisible === false ? "hidden" : "visible"

    const [endCurrentClicked, setEndCurrentClicked] = React.useState(false);
    const [endAppClicked, setEndAppClicked] = React.useState(false)

    useEffect(() => {
    }, [endAppClicked])

    const currentEvaluationIndex = () => {
        const value = Object.keys(collectedAnswersCopy).length;

        if (collectedAnswersCopy) {
            if (activePage === "start") { return value }
            else if (activePage === "end") { return value }
            else if (activePage.startsWith("question")) { return value + 1 }
        } else {
            return 1
        }
    }

    const endCurrentModalCondition = (activePage.startsWith("question") && setPageToStart && collectedAnswersCopy);
    const endModalStartCondition = (activePage === "start");
    const endModalEndCondition = (activePage === "end");

    const handleXBtnClick = () => {
        if (endCurrentModalCondition) {
            setEndCurrentClicked(true);

        } else if (endModalStartCondition) {
            setEndAppClicked(true);

        } else if (endModalEndCondition) {
            setEndAppClicked(true);
        }
    }

    const EndModalProps = {
        endAppClicked: endAppClicked,
        setEndAppClicked: setEndAppClicked,
        collectedAnswersCopy: collectedAnswersCopy,
        evaluationStage: evaluationStage,
        collectedAnswers: collectedAnswers,
    };

    const EndCurrentModalProps = {
        endCurrentClicked: endCurrentClicked,
        setEndCurrentClicked: setEndCurrentClicked,
        setCollectedAnswers: setCollectedAnswers,
        setPageToStart: setPageToStart || (() => { }), //Fallback to empty function for TS type adherenace.
        collectedAnswersCopy: collectedAnswersCopy,
    };

    return (
        <>
            <Box sx={{ width: "100%", ...flexSpaceR, height: "3rem" }}>
                <Box position="relative" display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{ aspectRatio: 1 / 1, border: "solid 2px black", borderRadius: "5px", height: "75%", fontWeight: 600, opacity: "25%", textAlign: "center", lineHeight: "1.2" }}>{currentEvaluationIndex()}</Box>
                {activePage.startsWith("question") ?
                    <Button onClick={handleXBtnClick} variant="outlined" sx={{
                        padding: 0,
                        minWidth: "auto",
                        opacity: "25%",
                        borderRadius: "2px",
                        ":hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                            color: "rgba(0, 0, 0, 0.75)",
                        },
                    }}><CloseIcon sx={{ fontSize: "2.5rem" }} />
                    </Button> :
                    <Button onClick={handleXBtnClick} variant="outlined"
                        color="secondary"
                        sx={{
                            borderRadius: "20px",
                            px: "1.25rem",
                            py: "0.66rem",
                        }}>{polyglot.t("evaluationTool.backForwardButtonBox.endBtn")}&nbsp;<ExitToAppIcon sx={{ fontSize: "2.75rem" }} />
                    </Button>
                }
            </Box>
            {endCurrentModalCondition && <EndCurrentModal {...EndCurrentModalProps} />}
            {endModalStartCondition && <EndModal {...EndModalProps} />}
            {endModalEndCondition && <EndModal {...EndModalProps} />}
        </>
    )
}

export default BackForwardButtonBox
